import { GET_ORDER_SUCCESS, GET_ORDER_ERROR } from '../actions/actionTypes'


const initialState = {
    fetching:true,
    fetched:false,
    error:null,
    result:{}
}
export default function orderReducer(state = initialState, {type, payload}) {
    switch (type) {
        case GET_ORDER_SUCCESS:
            return {
                ...state,
                fetching:false,
                fetched:true,
                result:payload
            }
            case GET_ORDER_ERROR:
            return {
                ...state,
                error:true
            }
        default:
            return state;
    }

}